export default "__VITE_ASSET__8bb41648__"